import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-limiter-exutoire',
  templateUrl: './limiter-exutoire.component.html',
  styleUrls: ['./limiter-exutoire.component.css']
})
export class LimiterExutoireComponent implements OnInit {

  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  factauto = {};
  avoirAuto = {};
  selected = [];
  dataArticle = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  condition1: Boolean = false;
  condition2: Boolean = false;
  isEdit: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  focusIndex = 0;
  selectedRow: any = {};
  listLimitExu = [];
  listExutoire: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
  tempClient: any = {};

  constructor(public common: CommonService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    this.isEmpty = false;
    this.tempClient = Object.assign({}, this.detail);
    this.tempClient.listeExutoires = this.tempClient.listeExutoires || [];
    this.tempClient.listeExutoires.forEach(elt => {
      this.listLimitExu.push(Object.assign({}, elt));
    });

    this.listLimitExu.forEach((elt, idx) => elt.id = idx + 1);
  }

  hide() {
    this.show.emit();
    this.listLimitExu.forEach(elt => delete elt.id);
    this.detail['listeExutoires'] = this.listLimitExu;
  }

  deleteLigne(row) {
    const temp = this.listLimitExu.filter(elt => elt !== row);
    this.listLimitExu = temp;
  }

  searchArticle(event) {
    this.dataArticle = [];
    const param = 1;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchChantier(event) {
    this.listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CRITERE': event || ''
      }
    };

    if (this.detail['id']) {
      return this.common.post('', { param: param }).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas)) {
          this.listChantier = [...this.listChantier, ...datas.data];
        }
      });
    }
  }

  searchExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct( param, event ).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        const l = [{ id: 0, libelleObjetEntite: 'Tous' }];
        l.push(...datas.data);
        this.listExutoire = l;
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  calculMontant(row) {
    if (row.qte && row.tarif) {
      row.prixHT = row.qte * row.tarif;
    } else {
      row.prixHT = 0;
    }
  }

  changeDate(event, row) {
    if (moment(event).isValid()) {
      row['dateDebut'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
    } else {
      row['dateDebut'] = moment().format('DD/MM/YYYY HH:mm:ss');
    }

    console.log(row['dateDebut']);

  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  showFormEdit(row?) {
    this.selectedRow = Object.assign({}, row);
    this.selectedRow.chantier = this.selectedRow.chantier || this.listChantier[0];
    this.isEdit = !this.isEdit;
  }

  validerFormEdit() {
    const temp = [];
    console.log(this.selectedRow.listeExutoires);
    if (!this.selectedRow.id) {
      this.listLimitExu.push(this.selectedRow);
      this.listLimitExu = [...this.listLimitExu];
    } else {
      this.listLimitExu.forEach(elt => {
        if (elt.id === this.selectedRow['id']) {
          elt = this.selectedRow;
        }
        temp.push(elt);
      });
      this.listLimitExu = temp;
      this.listLimitExu = [...this.listLimitExu];
    }
    this.listLimitExu.forEach(elt => delete elt.id);
    this.detail['listeExutoires'] = this.listLimitExu;
    console.log(this.listLimitExu);
    this.showFormEdit({});
  }

  addLigneDetail() {
    this.selectedRow.listeExutoires = this.selectedRow.listeExutoires || [];
    this.selectedRow.listeExutoires.push({});
    this.selectedRow.listeExutoires = [...this.selectedRow.listeExutoires];
    const ctrl = this;
    setTimeout(function () {
      const elem = $('datatable-scroller:last-child')[0].lastElementChild;
      $('.articleListe' + (ctrl.selectedRow.listeExutoires.length - 1)).focus();
    }, 600);
  }

  deleteLigneDetail(row) {
    const temp = this.selectedRow.listeExutoires.filter(elt => elt !== row);
    this.selectedRow.listeExutoires = temp;
    const ctrl = this;
    setTimeout(function () {
      const elem = $('datatable-scroller:last-child')[0].lastElementChild;
      $('.articleListe' + (ctrl.selectedRow.listeExutoires.length - 1)).focus();
    }, 600);
  }

  selectRow(row) {
    this.focusIndex = this.selectedRow.listeExutoires.indexOf(row);
    this.selected = [row];
  }


  setExutoire(event, idx) {
    this.selectedRow.listeExutoires[idx] = event;
    console.log(this.selectedRow.listeExutoires);
  }

  onDrag(event) {
    console.log(event);
    event.dragstart = true;
  }

  onDrop(event) {
    const newData = event.slice();
    newData.forEach(elt => elt.dragstart = false);
    this.selected = [];
    this.focusIndex = 0;

    this.renderTable = false;
    this.selectedRow.listeExutoires = [];

    setTimeout(() => {
      this.selectedRow.listeExutoires = [...newData];
      this.renderTable = true;
    }, 0);
  }

}
